import { ChangeEvent, KeyboardEvent, useCallback, useState } from "react";
import { searchLabelStyle, SearchSpacer } from "src/components/common/common";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SearchSectionDoubleForm } from "src/components/common/form/search/SearchSectionDoubleForm";
import { defaultKSK2011_R01Filter, useKSK2011_R01Store } from "./Store_KSK2011_R01";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import useUiuxStore from "src/store/useUiuxStore";
import { EmployeeDto } from "src/types/base";
import { getEmployeeList } from "src/apis/employeeApi";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";

interface Props {
  onEnterKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
}

export const SearchSection_KSK2011_R01 = (props: Props) => {

	const { onEnterKeyDown } = props;

    const { setCodeSearchModalProps } = useUiuxStore();
	const { KSK2011_R01Filter, setKSK2011_R01Filter } = useKSK2011_R01Store();
	const { compCdList, workPlaceList, jobTeamList, yesNoList } = useCommonCodeStore();

	
    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const handleOrderEmpFoucsId = 'orderEmp_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'orderEmp',
			category: '작업자',
			focusId: handleOrderEmpFoucsId,
			responseMapping: {
				empNo: 'orderEmp',
				empNm: 'orderEmpNm',
			},
			extraFilter: () => ({
				orderEmp: KSK2011_R01Filter.orderEmp || '',
				orderEmpNm: KSK2011_R01Filter.orderEmpNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: KSK2011_R01Filter,
		setEditData: setKSK2011_R01Filter,
		defaultData: defaultKSK2011_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'KSK2011_R01_search'
	});

	return (
		<SearchSectionDoubleForm >
			{/* PRD2020Filter : {JSON.stringify(KSK2011_R01Filter)} <br /> */}
			<SearchDropDownForm
				label="사업장"
				value={KSK2011_R01Filter.compCd}
				onChangeItem={(item) => setKSK2011_R01Filter({ compCd: item?.compCd || ''})}
				optionList={compCdList}
				wrapperOption={{
					wrapperStyle: "w-[200px] min-w-[200px] mr-[10px]",
					titleStyle: searchLabelStyle,
					selectStyle: "w-[150px] min-w-[150px]",
				}}
			/>
			<SearchDateRangeForm
					label="생산일자"
					visible={pickerVisible}
					setVisible={setPickerVisible}
					dateRange={KSK2011_R01Filter.dateRange}
					setDateRange={v => setKSK2011_R01Filter({  dateRange: v})}
					pickerPosition={pickerPosition}
					setPickerPosition={setPickerPosition}
				/>
			<SearchDropDownForm
				label="작업공정"
				value={KSK2011_R01Filter.workplaceCd}
				onChangeItem={(item) => setKSK2011_R01Filter({ workplaceCd: item?.workplaceCd || ''})}
				optionList={workPlaceList.filter(opt => opt.compCd === KSK2011_R01Filter.compCd)}
				editable={KSK2011_R01Filter.compCd !== ''}
				wrapperOption={{
					wrapperStyle: "w-[200px] min-w-[200px] mr-[10px]",
					titleStyle: searchLabelStyle,
					selectStyle: "w-[120px] min-w-[120px]",
				}}
			/>
			<SearchCodeModalForm
				label="작업자"
				value={KSK2011_R01Filter.orderEmp}
				valueLabel={KSK2011_R01Filter.orderEmpNm}
				handleFoucsId={handleOrderEmpFoucsId}
				onChange={getFieldHandlers('orderEmp').onChange}
				onDoubleClick={getFieldHandlers('orderEmp').onDoubleClick}
				onKeyDown={getFieldHandlers('orderEmp').onEnterKeyDown}
				wrapperOption={{
					wrapperStyle: "w-[350px] min-w-[350px] mr-[10px]",
					titleStyle: "w-[70px] min-w-[70px] text-left",
					codeInputStyle: "w-[190px] min-w-[190px]",
					nameTagStyle: "w-[170px] min-w-[170px] text-left",
				}}
			/>
		</SearchSectionDoubleForm>
	);
};